import React from "react"
import { ReactComponent as Svg } from "../../../../assets/images/loader.svg";

const Spinner2 = (props) => {
    return (
        <div style={{ backgroundColor: 'rgb(240 248 255 /  50%)', zIndex: 10000, minHeight: '60vh', width: '100%', position: 'absolute', textAlign: 'center', verticalAlign:'middle', height: '100%', display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Svg style={{ maxHeight: '100px', maxWidth: '100px', zIndex: 10000, position: 'fixed', top: '45%', left: '50%' }} />
            {props?.isAll == "All" && <div style={{ fontSize: '14px', fontWeight: 'bold', width: '225px', height: '25px', textAlign:'center', position: 'fixed', top: '54%', left: '50%', marginLeft: '-85px' }}>We are preparing data for you...</div>}
        </div>
    );
}
export default Spinner2;